/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPrintoutOptionsDto
 */
export interface NovitusPrintoutOptionsDto {
    /**
     * Wydruk bez nagłówka
     * @type {boolean}
     * @memberof NovitusPrintoutOptionsDto
     */
    without_header?: boolean;
    /**
     * Pozostaw lewy margines
     * @type {boolean}
     * @memberof NovitusPrintoutOptionsDto
     */
    left_margin?: boolean;
    /**
     * Tylko kopia (bez wydruku)
     * @type {boolean}
     * @memberof NovitusPrintoutOptionsDto
     */
    copy_only?: boolean;
    /**
     * Bez fizycznych marginesów
     * @type {boolean}
     * @memberof NovitusPrintoutOptionsDto
     */
    fiscal_margins_off?: boolean;
}

/**
 * Check if a given object implements the NovitusPrintoutOptionsDto interface.
 */
export function instanceOfNovitusPrintoutOptionsDto(value: object): value is NovitusPrintoutOptionsDto {
    return true;
}

export function NovitusPrintoutOptionsDtoFromJSON(json: any): NovitusPrintoutOptionsDto {
    return NovitusPrintoutOptionsDtoFromJSONTyped(json, false);
}

export function NovitusPrintoutOptionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPrintoutOptionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'without_header': json['without_header'] == null ? undefined : json['without_header'],
        'left_margin': json['left_margin'] == null ? undefined : json['left_margin'],
        'copy_only': json['copy_only'] == null ? undefined : json['copy_only'],
        'fiscal_margins_off': json['fiscal_margins_off'] == null ? undefined : json['fiscal_margins_off'],
    };
}

export function NovitusPrintoutOptionsDtoToJSON(value?: NovitusPrintoutOptionsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'without_header': value['without_header'],
        'left_margin': value['left_margin'],
        'copy_only': value['copy_only'],
        'fiscal_margins_off': value['fiscal_margins_off'],
    };
}

